<div class="flex items-center justify-between mb-5">
	<div class="flex items-center">
		<img src="assets/svg/error.svg" alt="" class="mr-2.5" />
		<p class="text-white text-[18px] leading-6 font-medium">{{ data.title }}</p>
	</div>
	<mat-icon class="text-white cursor-pointer" (click)="close()">close</mat-icon>
</div>
<div class="mb-5">
	<p class="text-white leasing-5 text-[14px]">{{ data.description }}</p>
</div>
<div class="flex items-center justify-end">
	<button
		class="py-2.5 px-4 border-[#4F5F6E] border border-solid rounded outline-none cursor-pointer bg-transparent text-white font-medium leading-5 text-[14px]"
		(click)="close()"
	>
		Try Again
	</button>
</div>
